<template>
  <el-container>
    <el-main>
      <span>{{ruleForm.id?'修改':'添加'}}Banner</span>
      <el-button type="warning" size="mini" style="float: right" @click="returnBack">返回</el-button>
      <el-divider class="divider"></el-divider>
      <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="Banner标题" label-width="100px" prop="name">
          <el-input class="input" placeholder="请输入Banner标题" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="上传图片" label-width="100px" prop="imgUrl">
          <el-upload
          class="avatar-uploader"
          :action="serverUrl"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="ruleForm.imgUrl" :src="ruleForm.imgUrl" class="avatar" alt="">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        </el-form-item>
        <el-form-item label="状态" label-width="100px" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label='1'>正常</el-radio>
            <el-radio :label='2'>禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" label-width="100px" prop="priority">
          <el-input class="input" placeholder="请输入排序" v-model="ruleForm.priority"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: -30%;text-align: center">
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import {saveArticle, updateArticle} from "../../../../api/system/articleSettings";
import {getCompanyByAdmin} from "../../../../api/system/org-storage";
import {mapGetters} from "vuex";

export default {
  name: "index",
  data() {
    return {
      ruleForm:{
        id:'',
        name:'',
        imgUrl:'',
        status:1,//1正常 2禁用
        priority:''
      },
      companyId:'',
      loading:false,
      serverUrl: 'https://wellhope.godaji.com/api/osp/articleSettings/image/upload',  // 这里写你要上传的图片服务器地址
      rules: {
        name: [
          { required: true, message: '请输入Banner标题', trigger: 'blur' },
        ],
        imgUrl: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ],
        priority: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.getCompanyByAdmin()
    if(this.$route.params.bannerList != null){
      this.ruleForm = JSON.parse(this.$route.params.bannerList)
      // console.log(this.ruleForm)
    }
  },
  methods:{
    getCompanyByAdmin(){
      let param = {'id':this.currentUser.id}
      getCompanyByAdmin(param).then(res => {
        if(res.data.length > 0){
          this.companyId = res.data[0].id
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    handleAvatarSuccess(res, file) {
      //this.imageUrl = URL.createObjectURL(file.raw);
      this.ruleForm.imgUrl = res.data
      // console.log(this.ruleForm.imgUrl)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    submitForm(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {}
          param.name = this.ruleForm.name
          param.imgUrl = this.ruleForm.imgUrl
          param.status = this.ruleForm.status
          param.priority = this.ruleForm.priority
          param.type = 3
          param.companyId = this.companyId
          if(this.ruleForm.id === ''){
            saveArticle(param).then(res => {
              if(res.code === 200){
                this.loading = false
                this.$message.success('保存成功');
                this.returnBack()
              }
            }).catch(()=>{
              this.loading = false
              this.$message.error('添加失败，请重试');
            })
          }else{
            param.id = this.ruleForm.id
            updateArticle(param).then(res => {
              if(res.code === 200){
                this.loading = false
                this.$message.success('保存成功');
                this.returnBack()
              }
            }).catch(()=>{
              this.loading = false
              this.$message.error('添加失败，请重试');
            })
          }
        }else{
          this.loading = false
          this.$message.error('添加失败，请重试');
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    returnBack(){
      this.$router.push({path: "/settings/banner/list"});
    }
  }
}
</script>

<style scoped>
  .avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader >>> .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 350px;
    height: 200px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 350px;
    height: 200px;
    display: block;
  }
  .divider{
    margin: 12px 0;
  }
  .form{
    margin-left: 30%;
    margin-top: 30px;
  }
  .input{
    width: 480px;
  }
</style>
